import { Grid, withTheme } from '@material-ui/core';
import { DateRangePicker } from '@material-ui/pickers';
import React, { useRef } from 'react';
import { CalendarRangeIcon, MinusIcon } from '../../icons';

function FilterRangePickerInternalInline({ startProps, endProps }) {
    // we should use own refs, since the startProps.ref is broken
    const startRef = useRef();
    const endRef = useRef();
    return (
        <>
            <div
                style={{ display: 'flex' }}
                className="datepicker"
                onClick={() => startRef.current && startRef.current.focus()}
            >
                <input
                    className="date-text"
                    style={{ border: 0, background: 'transparent', width: 130, textAlign: 'right' }}
                    {...startProps.inputProps}
                    ref={startRef}
                    placeholder={'select date'}
                    onChange={e => e.preventDefault()}
                />
                &nbsp;
                <MinusIcon
                    style={{
                        fontSize: '80%',
                        display: 'inline-block',
                        width: 'unset',
                        height: 'unset'
                    }}
                />
                &nbsp;
            </div>
            <div className="datepicker" onClick={() => endRef.current && endRef.current.focus()}>
                <input
                    className="date-text"
                    style={{ border: 0, background: 'transparent', width: 130 }}
                    {...endProps.inputProps}
                    ref={endRef}
                    placeholder={'select date'}
                    onChange={e => e.preventDefault()}
                />
            </div>
        </>
    );
}
function FilterRangePickerInternal({ startProps, endProps, theme, label }) {
    // we should use own refs, since the startProps.ref is broken
    const startRef = useRef();
    const endRef = useRef();
    return (
        <Grid
            item
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            style={{ margin: 0 }}
        >
            <Grid item container className="golf-picker" justifyContent="center">
                <Grid item>
                    <p>{label}</p>
                    <Grid item>
                        <div
                            className="datepicker"
                            onClick={() => startRef.current && startRef.current.focus()}
                        >
                            <div className="dropdown">
                                <input
                                    className="date-text"
                                    {...startProps.inputProps}
                                    ref={startRef}
                                    onChange={e => e.preventDefault()}
                                />
                                <CalendarRangeIcon
                                    style={{
                                        color: theme.palette.primary.main
                                    }}
                                />
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item container className="golf-picker" justifyContent="center">
                <Grid item>
                    <Grid item>
                        <div
                            className="datepicker"
                            onClick={() => endRef.current && endRef.current.focus()}
                        >
                            <div className="dropdown">
                                <input
                                    className="date-text"
                                    {...endProps.inputProps}
                                    ref={endRef}
                                    onChange={e => e.preventDefault()}
                                />
                                <CalendarRangeIcon
                                    style={{
                                        color: theme.palette.primary.main
                                    }}
                                />
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
function FilterRangePicker({
    filters,
    setFilters,
    disablePast = true,
    theme,
    label,
    mask = 'dddd, MMMM Do, YYYY',
    fromKey = 'checkInDate',
    toKey = 'checkOutDate',
    inlineVariant = false
}) {
    return (
        <DateRangePicker
            disablePast={disablePast}
            value={[filters[fromKey], filters[toKey]]}
            onChange={newValue => {
                if (newValue[0] === null || newValue[1] === null) {
                    return;
                }
                // both set, we are good
                if (newValue[0] && newValue[1]) {
                    setFilters({
                        ...filters,
                        [fromKey]: newValue[0],
                        [toKey]: newValue[1]
                    });
                }
                // only start set, let's modify end if it's < start
                else if (newValue[0]) {
                    if (filters[toKey].isBefore(newValue[0])) {
                        setFilters({
                            ...filters,
                            [fromKey]: newValue[0],
                            [toKey]: newValue[0]
                        });
                    } else {
                        setFilters({ ...filters, [fromKey]: newValue[0] });
                    }
                }
                // only end set, let's modify start if it's > end
                else if (newValue[1]) {
                    if (filters[fromKey].isAfter(newValue[1])) {
                        setFilters({
                            ...filters,
                            [fromKey]: newValue[1],
                            [toKey]: newValue[1]
                        });
                    } else {
                        setFilters({ ...filters, [toKey]: newValue[1] });
                    }
                }
            }}
            inputFormat={mask}
            // not sure if it is the correct way to handle this,
            // but since we don't accept input from the keyboard in this component, it should be fine
            disableMaskedInput
            renderInput={(startProps, endProps) => {
                if (inlineVariant) {
                    return (
                        <FilterRangePickerInternalInline
                            startProps={startProps}
                            endProps={endProps}
                            theme={theme}
                            label={label}
                        />
                    );
                }
                return (
                    <FilterRangePickerInternal
                        startProps={startProps}
                        endProps={endProps}
                        theme={theme}
                        label={label}
                    />
                );
            }}
        />
    );
}

export default withTheme(FilterRangePicker);
